import { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Menu, Input, Sidebar, Dropdown } from "semantic-ui-react";
import LanguageMenu from "components/LanguageMenu/LanguageMenu";
import { logout } from "services/auth";
import { getPages } from "store/selectors";

const AppBarMobile = (props) => {
  const { currentPageKey, onAppBarPageClick, t } = props;
  const { showSidebar } = useDispatch().ui;
  const pages = useSelector(getPages);
  const currentPage = useMemo(() => pages.find((p) => p.key === currentPageKey), [
    currentPageKey,
    pages,
  ]);

  return (
    <Menu className="app-bar" borderless>
      <Menu.Item onClick={showSidebar} icon="bars"></Menu.Item>
      {currentPage && (
        <Menu.Item
          as={Link}
          to={currentPage.path}
          // exact={currentPage.exact}
          active
          onClick={onAppBarPageClick}
        >
          {t(currentPage.tKey)}
        </Menu.Item>
      )}
      <Menu.Menu position="right">
        <LanguageMenu />
        <Dropdown item icon="search" simple direction="left">
          <Dropdown.Menu>
            <Input placeholder="Hae sivulta" />
          </Dropdown.Menu>
        </Dropdown>
      </Menu.Menu>
    </Menu>
  );
};

const AppSideBar = () => {
  const visible = useSelector((state) => state.ui.sidebarIsVisible);
  const { hideSidebar } = useDispatch().ui;
  const { t } = useTranslation("common");
  const location = useLocation();
  const pages = useSelector(getPages);

  return (
    <Sidebar
      as={Menu}
      animation="push"
      direction="left"
      icon="labeled"
      vertical
      visible={visible}
      width="thin"
      onHide={hideSidebar}
    >
      {pages.map((page) => (
        <Menu.Item
          key={page.key}
          as={Link}
          to={page.path}
          exact={page && page.exact && page.exact.toString()}
          active={page.path === location.pathname}
          onClick={hideSidebar}
        >
          {t(page.tKey)}
        </Menu.Item>
      ))}
      <Menu.Item onClick={logout}>{t("logout")}</Menu.Item>
    </Sidebar>
  );
};

export default AppBarMobile;
export { AppSideBar };
